import { ViewPortBreakpoint } from "../../domain/view-port/view-port-breakpoints.js";
//#region src/redux/view-port/initial-state.ts
var viewPortInitialState = {
	viewPort: {
		width: 0,
		height: 0,
		breakpoint: ViewPortBreakpoint.DESKTOP
	},
	isPending: false,
	isRejected: false,
	errorMessage: ""
};
//#endregion
export { viewPortInitialState };

//# sourceMappingURL=initial-state.js.map